import { render, staticRenderFns } from "./PprNoPopupTable.vue?vue&type=template&id=22a013b4&"
import script from "./PprNoPopupTable.vue?vue&type=script&lang=js&"
export * from "./PprNoPopupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports